import { render, staticRenderFns } from "./OrdenesDeCompra.vue?vue&type=template&id=3f890030&scoped=true"
import script from "./OrdenesDeCompra.vue?vue&type=script&lang=js"
export * from "./OrdenesDeCompra.vue?vue&type=script&lang=js"
import style0 from "./OrdenesDeCompra.vue?vue&type=style&index=0&id=3f890030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f890030",
  null
  
)

export default component.exports